// https://ssr.vuejs.org/guide/head.html
const getMeta = (vm) => {
  const { meta = '' } = vm.$options

  return typeof meta === 'function' ? meta.call(vm) : meta
}

const serverMetaMixin = {
  created() {
    const meta = getMeta(this)

    if (meta) {
      this.$ssrContext.meta = meta
    }
  }
}

const clientMetaMixin = {
  mounted() {
    const { title } = getMeta(this) || { title: this.name }

    if (title) {
      document.title = title
    }
  }
}

export const meta = process.env.VUE_ENV === 'server' ? serverMetaMixin : clientMetaMixin
